import {Injectable} from '@angular/core';
import {BaseRestService} from '../../common/BaseRestService';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  GoodStandingRegionWorldData,
  GsatData,
  PolicyDocumentsRegionWorldData,
  ProjectCountData,
  AnnualFinancialReportingData, SafeFromHarmRegionWorldData
} from '../../../types/nso-data-portal/dashboard-data';
import {RegionData} from '../../../types/nso-data-portal/entity-data';

@Injectable()
export class WorldInformationRestService extends BaseRestService {

  constructor(private http: HttpClient) {
    super('ndp_world');
  }

  getWorldInformation(): Observable<RegionData> {
    return this.http.get<RegionData>(this.getEndpoint());
  }

  getGoodStanding(): Observable<GoodStandingRegionWorldData> {
    return this.http.get<GoodStandingRegionWorldData>(this.getEndpoint(['good-standing']));
  }

  getAnnualReporting(): Observable<AnnualFinancialReportingData> {
    return this.http.get<AnnualFinancialReportingData>(this.getEndpoint(['annual-reporting']));
  }

  getPolicyDocuments(): Observable<PolicyDocumentsRegionWorldData[]> {
    return this.http.get<PolicyDocumentsRegionWorldData[]>(this.getEndpoint(['policy-documents']));
  }

  getConstitutionInformation(): Observable<number> {
    return this.http.get<number>(this.getEndpoint(['constitution-information']));
  }

  getGsat(): Observable<GsatData> {
    return this.http.get<GsatData>(this.getEndpoint(['gsat']));
  }

  getCompliancy(): Observable<number> {
    return this.http.get<number>(this.getEndpoint(['compliancy']));
  }

  getProjectCount(): Observable<ProjectCountData> {
    return this.http.get<ProjectCountData>(this.getEndpoint(['project-count']));
  }

  getSafeFromHarm(): Observable<SafeFromHarmRegionWorldData> {
    return this.http.get<SafeFromHarmRegionWorldData>(this.getEndpoint(['safe-from-harm']));
  }

  getExport(exportParams: any) {
    const params = new HttpParams()
      .set('yearFrom', String(exportParams.yearFrom))
      .set('yearTo', String(exportParams.yearTo))
      .set('level', exportParams.entityExportChoiceLevel);
    return this.http.get(
      this.getEndpoint(['census', 'export']),
      {
        params,
        responseType: 'blob',
        observe: 'response',
      });
  }

  getNDPExport(selectedYear): any {
    const params = new HttpParams()
      .set('from', String(selectedYear - 1))
      .set('to', String(selectedYear));
    return this.http.get(
      this.getEndpoint(['ndp-data-export']),
      {
        params,
        responseType: 'blob',
        observe: 'response',
      });
  }
}
